var render = function render(){var _vm=this,_c=_vm._self._c;return _c('dataQueryTemplate1',{ref:"dataQueryTemplate1"})
}
var staticRenderFns = []

export { render, staticRenderFns }